import * as React from 'react';
import PropsChecker from '@core-front/props-checker';
const OptionCardGroupCore = (props) => {
    return (React.createElement(PropsChecker, { componentName: "OptionCardGroup", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        React.createElement(OptionCardGroupCoreInner, Object.assign({}, props))));
};
export default OptionCardGroupCore;
export class OptionCardGroupCoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = (value, checked, onChange) => {
            let newValue = null;
            if (this.props.inputType === 'checkbox') {
                newValue = Array.isArray(this.value) ? [...this.value] : [];
                if (checked) {
                    newValue.push(value);
                }
                else {
                    newValue = newValue.filter(item => item !== value);
                }
            }
            else {
                newValue = value;
            }
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value: newValue,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(newValue);
            }
            if (onChange) {
                onChange(checked);
            }
        };
        this.state = {
            value: props.defaultValue || null,
        };
    }
    get value() {
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    isChecked(value) {
        const currentValue = this.value;
        if (this.props.inputType === 'checkbox' && currentValue) {
            return value === currentValue || currentValue.indexOf(value) !== -1;
        }
        else {
            return value === currentValue;
        }
    }
    get isInvalid() {
        if (this.props.helper) {
            return this.props.helper.type === 'error';
        }
        return !!this.props.isInvalid;
    }
    get optionCardProps() {
        const { background, type } = this.props;
        return {
            background,
            type,
        };
    }
    getOptionInput(option) {
        if (this.props.inputType === 'radio') {
            return Object.assign(Object.assign({}, option.input), { name: this.props.name });
        }
        else {
            return Object.assign({}, option.input);
        }
    }
    renderOptionCard(child, key) {
        const props = child.props;
        const value = props.value || 'on';
        const onChange = (checked) => this.onChange(value, checked, props.onChange);
        const { OptionCard } = this.props.components;
        return (React.createElement(OptionCard, Object.assign({}, this.optionCardProps, props, { checked: this.isChecked(value), index: key, input: this.getOptionInput(props), inputType: this.props.inputType, onChange: onChange, isInvalid: this.isInvalid })));
    }
    renderNotice() {
        const { components: { Notice }, } = this.props;
        return React.createElement(Notice, { size: "small", children: true });
    }
    getChildren() {
        const { GridColumn, OptionCard, CarouselItem } = this.props.components;
        return React.Children.toArray(this.props.children)
            .filter((child) => {
            return React.isValidElement(child);
        })
            .map((child, key) => {
            const isOptionCard = this.props.isOptionCard ? this.props.isOptionCard(child) : child && child.type === OptionCard;
            if (this.props.carousel) {
                return React.createElement(CarouselItem, { key: key }, isOptionCard ? this.renderOptionCard(child, key) : child);
            }
            return (React.createElement(GridColumn, Object.assign({}, this.props.gridColumn, { key: key }), isOptionCard ? this.renderOptionCard(child, key) : child));
        });
    }
    BEM() {
        const classArray = ['option-card-group'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const { grid } = this.props;
        const { Grid, Carousel } = this.props.components;
        if (this.props.carousel) {
            return (React.createElement(Carousel, Object.assign({ afterSlidesContent: this.props.helper && this.renderNotice(), className: this.BEM(), hasContainer: true }, this.props.carousel), this.getChildren()));
        }
        return (React.createElement("div", { className: this.BEM() },
            React.createElement(Grid, Object.assign({ equalHeight: true }, grid), this.getChildren()),
            this.props.helper && this.renderNotice()));
    }
}
